import { NgModule, Component, ViewChild, ViewChildren, OnInit, AfterViewInit, SecurityContext, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router, Route } from "@angular/router";
import { RouteURLConstants } from '../../../../constants/upplm.constants';
import { DashboardResponse } from '../../../../api/models/dashboardResponse';

@Component({
    selector: 'qvcreated2',
    template: require('./qvdashboardCreated2.component.html')
})

export class QVCreated2Component {

    public ham: boolean = false;
    public paramsUrl: string = '?loc=en_US&placardid=';
    public placardID: string = '';
    @Output() placardIdDetail = new EventEmitter<string>();

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;

    constructor(private router: Router) { }

    ngOnInit() {
        /*empty*/
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }    
    showDetail(placardId: string) {
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }
}